import { useEffect, useRef, useState } from 'react';
import { useKeyboard } from './useKeyboard';

export function useDebounce<T>(value: T, delay = 500): T {
  const [debouncedValue, setDebouncedValue] = useState(value);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  const clear = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
  };

  useKeyboard({
    keyDown: (event) => {
      if (event.key === 'Enter' && value) {
        clear();
        setDebouncedValue(value);
      }
    },
  });

  useEffect(() => {
    clear();
    timeoutRef.current = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return clear;
  }, [value, delay]);

  return debouncedValue;
}
